import { useEffect } from "react";
import { createPortal } from "react-dom";

export function SimpleDialog({ open, onOpenChange, children, className = "" }) {
  // Lock body scroll while open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return createPortal(
    // Backdrop — clicking it closes the dialog
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: "rgba(0,0,0,0.80)" }}
      onMouseDown={(e) => {
        // Close only when the backdrop itself is clicked, not the dialog content
        if (e.target === e.currentTarget) onOpenChange(false);
      }}
    >
      {/* Dialog panel — pointer-events explicitly enabled so buttons are always clickable */}
      <div
        className={`relative z-50 w-full max-w-md pointer-events-auto ${className}`}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
